import { type HTMLAttributes, type ReactNode } from "react";

/**
 * Container for response action buttons. Doesn't gate visibility itself —
 * each button (Approve, Reject, Respond) reads `interrupt.config.allow_*`
 * and renders null when its slot is disallowed. Consumers can therefore
 * include all three children unconditionally; only the allowed ones
 * surface in the rendered output.
 */
export interface ActionsProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Actions({ children, ...props }: ActionsProps) {
  return (
    <div
      {...props}
      className={["flex flex-wrap items-center gap-2", props.className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
}
